import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  Button,
  Modal,
  Box,
  Stepper,
  Step,
  StepLabel,
  Select,
  MenuItem,
  LinearProgress,
  Typography,
  Grid,
  Avatar,
  Chip,
  Skeleton,
  IconButton,
  Fade,
  Slide,
  Alert,
  Slider,
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
  styled,
  TextField,
  Snackbar ,
  Input,
  FormControl,
  InputLabel,
  CircularProgress
} from '@mui/material';
import { Close, ArrowBack, CheckCircle, Error, HourglassTop, Delete, Circle,CloudUpload,CheckCircle as CheckCircleIcon,
  Error as ErrorIcon } from '@mui/icons-material';
import ApiService from '../../API/Requesthandler';
import { motion } from 'framer-motion';

const MotionCard = motion(Card);

const ModernSelect = styled(Select)(({ theme }) => ({
  borderRadius: '12px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.divider,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
}));



const NumberSelector = ({ value, setValue, min = 0, max = 100 }) => {
  const theme = useTheme();
  return (
    // <Box sx={{ width: '100%', px: 2, py: 3, background: theme.palette.background.paper, borderRadius: 3 }}>
    //   <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
    //     Members to Process
    //   </Typography>
    //   <Slider
    //     value={value}
    //     onChange={(e, newValue) => setValue(newValue)}
    //     aria-labelledby="number-selector-slider"
    //     valueLabelDisplay="auto"
    //     min={min}
    //     max={max}
    //     sx={{
    //       color: theme.palette.primary.main,
    //       '& .MuiSlider-thumb': {
    //         width: 20,
    //         height: 20,
    //         background: theme.palette.background.paper,
    //         border: `3px solid ${theme.palette.primary.main}`,
    //       },
    //       '& .MuiSlider-valueLabel': {
    //         background: theme.palette.primary.main,
    //         borderRadius: 2,
    //         fontSize: 14,
    //         fontWeight: 500,
    //       }
    //     }}
    //   />
    //   <Typography variant="h6" align="center" sx={{ mt: 1, fontWeight: 700 }}>
    //     {value}
    //   </Typography>
    // </Box>
    <></>
  );
};

const MembersScraper = () => {
  const theme = useTheme();
  const [tasks, setTasks] = useState([]);
  const [open, setOpen] = useState(false);
  
  const [activeStep, setActiveStep] = useState(0);
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [dialogs, setDialogs] = useState([]);
  const [selectedSource, setSelectedSource] = useState('');
  const [selectedTarget, setSelectedTarget] = useState('');
  const [loadingAccounts, setLoadingAccounts] = useState(false);
  const [loadingDialogs, setLoadingDialogs] = useState(false);
  const [creatingTask, setCreatingTask] = useState(false);
  const [numberValue, setNumberValue] = useState(50);
  const [filterStatus, setFilterStatus] = useState('all');
  const [targetOption, setTargetOption] = useState('group');
const [selectedFile, setSelectedFile] = useState(null);
const [fileContent, setFileContent] = useState(null);
const [isProcessingFile, setIsProcessingFile] = useState(false);
// const [isProcessing, setIsProcessing] = useState(false);
const [processedData, setProcessedData] = useState([]);
const [processingProgress, setProcessingProgress] = useState(0);


const [inviteTextModalOpen, setInviteTextModalOpen] = useState(false);
  const [inviteText, setInviteText] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [isUpdatingText, setIsUpdatingText] = useState(false);

const [error, setError] = useState(null);

  const StepIcon = (props) => {
    const { active, completed } = props;
    return (
      <Box
        sx={{
          width: 24,
          height: 24,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: completed ? theme.palette.primary.main : active ? theme.palette.primary.light : theme.palette.action.disabled,
          color: completed ? '#fff' : active ? theme.palette.primary.main : theme.palette.text.secondary,
          borderRadius: '50%',
          transition: 'all 0.3s ease',
        }}
      >
        {completed ? <CheckCircle sx={{ fontSize: 18 }} /> : <Circle sx={{ fontSize: 18 }} />}
      </Box>
    );
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    setError(null);
    setSelectedFile(null);
    setFileContent(null);
    setProcessedData([]);
  
    if (!file) return;
  
    try {
      setIsProcessingFile(true);
      setProcessingProgress(0);
  
      // Get file size for progress calculation
      const fileSize = file.size;
      let bytesRead = 0;
  
      const reader = file.stream().getReader();
      const decoder = new TextDecoder();
      let jsonString = '';
  
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
  
        // Update bytes read
        bytesRead += value.byteLength;
  
        // Calculate progress percentage
        const progress = Math.min((bytesRead / fileSize) * 100, 95);
        setProcessingProgress(progress); // This will now update properly
  
        // Convert chunk to text
        jsonString += decoder.decode(value, { stream: true });
      }
  
      // Final parse and processing
      const content = JSON.parse(jsonString);
      const formattedData = processJsonContent(content);
      
      // Update final state
      setProcessingProgress(100);
      setProcessedData(formattedData);
      setSelectedFile(file);
      setFileContent(formattedData);
  
    } catch (error) {
      setError(error.message || 'Error processing file');
    } finally {
      setIsProcessingFile(false);
    }
  };

  const processJsonContent = (content) => {
    try {
        if (!content || !Array.isArray(content)) {
            throw new Error('JSON root must contain a "messages" array');
        }

        const seenIds = new Set();

        return content
            .map(message => {
                let id, name;

                
                    if (!message.id || !message.username) {
                        console.warn('Invalid regular message:', message);
                        return null;
                    }
                    id = message.id;
                    name = message.username;
                
                // Convert ID to string and remove "user" prefix if present
                let stringId = String(id).replace(/^user/, ""); 

                // Ensure ID is at least 9 digits long
                if (!/^\d{9,}$/.test(stringId)) {
                    console.warn(`Skipping invalid ID (must be 9+ digits): ${stringId}`);
                    return null;
                }

                // Check for duplicate IDs
                if (seenIds.has(stringId)) {
                    console.warn(`Duplicate ID found: ${stringId}`);
                    return null;
                }

                seenIds.add(stringId);

                return {
                    name: name,
                    id: stringId
                };
            })
            .filter(Boolean);
    } catch (error) {
        throw new Error(`Invalid data structure: ${error.message}`);
    }
};



  const fetchTasks = async () => {
    try {
      const response = await ApiService.get('/api/members_scraper/task-status/9897979031270');
      setTasks(response.data.reverse());
    } catch (error) {
      console.error('Failed to fetch tasks:', error);
    }
  };

  
  useEffect(() => {
    

    fetchTasks();
    const interval = setInterval(fetchTasks, 20000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchAccounts = async () => {
      setLoadingAccounts(true);
      try {
        const response = await ApiService.post('/api/phone/sessions', {
          user_id: JSON.parse(localStorage.getItem('user-data'))?.id
        });
        const formattedSessions = response.map(session => ({
          id: session.id,
          phone_number: session.phone,
          status: 'active',
          username: session.username
        }));
        setAccounts(formattedSessions);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingAccounts(false);
      }
    };

    if (open) fetchAccounts();
  }, [open]);


  const handleUpdateInviteText = async () => {
    setIsUpdatingText(true);
    try {
      const response = await ApiService.post('/api/members_scraper/setText', { text: inviteText });
      
      if (response.success === true) {
        setSnackbarSeverity('success');
        setSnackbarMessage('Invite text updated successfully!');
      } else {
        setSnackbarSeverity('error');
        setSnackbarMessage('Failed to update invite text');
      }
    } catch (error) {
      setSnackbarSeverity('error');
      setSnackbarMessage('Error updating invite text');
    } finally {
      setSnackbarOpen(true);
      setIsUpdatingText(false);
      setInviteTextModalOpen(false);
    }
  };

  // Add the Snackbar component
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  useEffect(()=>{
    const fetchData = async()=>{
      const response = await ApiService.get(
            '/api/members_scraper/getText'
          );
          if (response.success === true) {
            setInviteText(response.text);
          }
    }

    fetchData()
  },[])

  useEffect(() => {
    const fetchDialogs = async () => {
      if (selectedAccount) {
        setLoadingDialogs(true);
        try {
          const response = await ApiService.get(
            `/api/chat/get/${JSON.parse(localStorage.getItem('user-data'))?.id}/${selectedAccount.phone_number}`
          );
          if (response.success) {
            setDialogs(response.data);
          }
        } catch (err) {
          console.error(err);
        } finally {
          setLoadingDialogs(false);
        }
      }
    };

    fetchDialogs();
  }, [selectedAccount]);

  const handleCreateTask = async () => {
    setCreatingTask(true);
    try {
      const response = await ApiService.post('/api/members_scraper/start-process', {
        source_group_id: selectedSource,
        target_group_id: fileContent ? "" : selectedTarget,
        phone: selectedAccount.phone_number,
        file_users: fileContent ? fileContent : ""
      });
      if (response.message === "Process started"){
        fetchTasks()
      }
      handleClose();
    } catch (error) {
      console.error('Failed to create task:', error);
    } finally {
      setCreatingTask(false);
    }
  };

  const handleDeleteTask = async (taskId) => {
    try {
      await ApiService.delete(`/api/members_scraper/delete/${taskId}`);
      setTasks(prev => prev.filter(task => task.id !== taskId));
    } catch (error) {
      console.error('Delete task failed:', error);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setActiveStep(0);
    setSelectedAccount(null);
    setSelectedSource('');
    setSelectedTarget('');
  };

  const calculateDuration = (start, end) => {
    const startDate = new Date(start);
    const endDate = end ? new Date(end) : new Date();
    const diff = Math.abs(endDate - startDate);
    
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  
    return `${days}d ${hours}h ${minutes}m`;
  };
  
  const getStatusIcon = (status) => {
    const iconStyle = { fontSize: 20, mr: 1 };
    
    switch(status) {
      case 'completed':
        return <CheckCircle color="success" sx={iconStyle} />;
      case 'failed':
        return <Error color="error" sx={iconStyle} />;
      case 'processing':
        return <HourglassTop color="warning" sx={iconStyle} />;
      default:
        return <HourglassTop color="info" sx={iconStyle} />;
    }
  };

  const filteredTasks = tasks.filter(task => {
    if (filterStatus === 'all') return true;
    if (filterStatus === 'completed') return task.status === 'completed';
    if (filterStatus === 'adding') return task.status !== 'completed';
    return true;
  });

  return (
    <Box sx={{ p: 4, maxWidth: '100%', background: theme.palette.background.default }}>
      <Box sx={{
        mb: 4,
        p: 4,
        borderRadius: 4,
        background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        boxShadow: theme.shadows[4],
        color: '#fff'
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>Member Scraper</Typography>
          <Button
            variant="contained"
            onClick={() => setOpen(true)}
            sx={{
              background: '#fff',
              color: theme.palette.primary.main,
              borderRadius: 3,
              px: 4,
              py: 1.5,
              fontWeight: 600,
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: theme.shadows[6],
                background: '#fff'
              }
            }}
          >
            + Create Task
          </Button>

          



        </Box>
        


        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt:2 }}>
          <ToggleButtonGroup
          value={filterStatus}
          exclusive
          onChange={(e, newValue) => newValue && setFilterStatus(newValue)}
          sx={{ mt: 3 }}
        >
          {['all', 'completed', 'adding'].map((status) => (
            <ToggleButton
              key={status}
              value={status}
              sx={{
                textTransform: 'capitalize',
                color: '#fff',
                borderColor: 'rgba(255,255,255,0.3)!important',
                '&.Mui-selected': {
                  background: 'rgba(255,255,255,0.15)!important',
                  fontWeight: 600
                }
              }}
            >
              {status}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>

        <Button
            variant="outlined"
            onClick={() => setInviteTextModalOpen(true)}
            sx={{
              // background: '#fff',
              maxHeight:50,
              
              color: 'white',
              borderRadius: 3,
              px: 4,
              py: 1.5,
              fontWeight: 600,
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: theme.shadows[6],
                background: 'rgba(255,255,255,0.15)!important'
              }
            }}
          >
            Set Invite Text
          </Button>
        </Box>
      </Box>

      <Grid container spacing={3}>
  {filteredTasks.map((task, index) => (
    <Grid item xs={12} md={6} lg={4} key={task.id}>
      <MotionCard
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: index * 0.05 }}
        sx={{
          borderRadius: 3,
          border: `1px solid ${theme.palette.divider}`,
          background: theme.palette.background.paper,
          '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: theme.shadows[4]
          }
        }}
      >
        <CardContent>
          {/* Card Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{ 
                bgcolor: theme.palette.primary.main,
                width: 40,
                height: 40,
                fontSize: 16,
                fontWeight: 600
              }}>
                {task?.user_id ? task.user_id : "" || '--'}
              </Avatar>
              <Box>
                <Typography variant="subtitle1" fontWeight={600}>
                  {task?.user_phone ? task?.user_phone : ""}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Task ID: {task?.id ? task?.id : ""}
                </Typography>
              </Box>
            </Box>
            <IconButton onClick={() => handleDeleteTask(task.id)} size="small">
              <Delete color="error" />
            </IconButton>
          </Box>

          {/* Progress Section */}
          <Box sx={{ mb: 2 }}>
            <LinearProgress
              variant="determinate"
              value={(task?.added_count + task?.invited_count) / task?.scraped_count * 100}
              sx={{
                height: 8,
                borderRadius: 4,
                background: theme.palette.action.disabledBackground,
                '& .MuiLinearProgress-bar': {
                  borderRadius: 4,
                  background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`
                }
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
              <Typography variant="caption" color="text.secondary">
                {task.progress}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {Math.round(((task?.added_count + task?.invited_count) / task?.scraped_count) * 100)}%
              </Typography>
            </Box>
          </Box>

          {/* Stats Grid */}
          <Grid container spacing={1} sx={{ mb: 2 }}>
            <Grid item xs={4}>
              <Box sx={{ textAlign: 'center', p: 1, background: theme.palette.background.default, borderRadius: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">Scraped</Typography>
                <Typography variant="h6" fontWeight={700}>
                  {task.scraped_count}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box sx={{ textAlign: 'center', p: 1, background: theme.palette.background.default, borderRadius: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">Added</Typography>
                <Typography variant="h6" fontWeight={700} color="success.main">
                  {task?.added_count}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box sx={{ textAlign: 'center', p: 1, background: theme.palette.background.default, borderRadius: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">Invited</Typography>
                <Typography variant="h6" fontWeight={700} color="info.main">
                  {task.invited_count}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Status & Metadata */}
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            p: 1.5,
            borderRadius: 2,
            background: theme.palette.action.selected
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {getStatusIcon(task.status)}
              <Box>
                <Typography variant="subtitle2" sx={{ lineHeight: 1 }}>
                  {task.status}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {task.status === 'completed' ? 'Finished' : 'In progress'}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="caption" display="block" color="text.secondary">
                Created: {new Date(task.created_at).toLocaleDateString()}
              </Typography>
              <Typography variant="caption" display="block" color="text.secondary">
                Duration: {calculateDuration(task.created_at, task.updated_at)}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </MotionCard>
    </Grid>
  ))}
</Grid>

      <Modal open={open} onClose={handleClose} closeAfterTransition>
        <Fade in={open}>
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', md: 600 },
            bgcolor: 'background.paper',
            borderRadius: 4,
            boxShadow: 24,
            p: 3,
            outline: 'none'
          }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6" fontWeight={700}>New Task</Typography>
              <IconButton onClick={handleClose} size="small">
                <Close />
              </IconButton>
            </Box>

            <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
              {['Account', 'Groups', 'Confirm'].map((label) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={StepIcon} sx={{
                    '& .MuiStepLabel-label': {
                      fontWeight: 500,
                      color: theme.palette.text.primary,
                      mt: 1
                    }
                  }}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>

            <Box sx={{ minHeight: 300 }}>
              <Slide direction="right" in={activeStep === 0} mountOnEnter unmountOnExit>
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 2 }}>Select an account</Typography>
                  <Grid container spacing={2}>
                    {loadingAccounts ? Array(3).fill().map((_, i) => (
                      <Grid item xs={12} key={i}>
                        <Skeleton variant="rounded" height={80} />
                      </Grid>
                    )) : accounts.map(account => (
                      <Grid item xs={12} key={account.id}>
                        <Card
                          onClick={() => setSelectedAccount(account)}
                          sx={{
                            p: 2,
                            borderRadius: 2,
                            cursor: 'pointer',
                            border: 2,
                            borderColor: selectedAccount?.id === account.id ? 'primary.main' : 'divider',
                            transition: 'all 0.2s',
                            '&:hover': {
                              borderColor: 'primary.main',
                              boxShadow: theme.shadows[2]
                            }
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Avatar sx={{ bgcolor: 'primary.main' }}>
                              {account.username?.[0] || account.phone_number?.[0]}
                            </Avatar>
                            <Box>
                              <Typography fontWeight={500}>
                                {account.username || 'Unnamed Account'}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                {account.phone_number}
                              </Typography>
                            </Box>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Slide>

              <Slide direction="left" in={activeStep === 1} mountOnEnter unmountOnExit>
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 2 }}>Select Groups</Typography>
                  <Box sx={{ '& > * + *': { mt: 3 } }}>
                    <Box>
                      <Typography variant="body2" sx={{ mb: 1 }}>Source Group</Typography>
                      <ModernSelect
                        fullWidth
                        value={selectedSource}
                        onChange={(e) => setSelectedSource(e.target.value)}
                        displayEmpty
                        MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
                        disabled={loadingDialogs}
                      >
                        <MenuItem disabled value="">
                          {loadingDialogs ? 'Loading groups...' : 'Select source group'}
                        </MenuItem>
                        {dialogs.map(dialog => (
                          <MenuItem key={dialog.id} value={dialog.id}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                              <Typography>{dialog.name}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {dialog.id}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))}
                      </ModernSelect>
                    </Box>

                    <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="body2">Target Group</Typography>
                      {/* <ToggleButtonGroup
                        value={targetOption}
                        exclusive
                        onChange={(e, newValue) => newValue && setTargetOption(newValue)}
                        size="small"
                      >
                        <ToggleButton value="group" sx={{ textTransform: 'none' }}>
                          Select Group
                        </ToggleButton>
                        <ToggleButton value="file" sx={{ textTransform: 'none' }}>
                          Upload JSON
                        </ToggleButton>
                      </ToggleButtonGroup> */}
                      </Box>
                      
                      {targetOption === 'group' ? (
                      <ModernSelect
                        fullWidth
                        value={selectedTarget}
                        onChange={(e) => setSelectedTarget(e.target.value)}
                        displayEmpty
                        MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
                        disabled={loadingDialogs}
                      >
                        <MenuItem disabled value="">
                          {loadingDialogs ? 'Loading groups...' : 'Select target group'}
                        </MenuItem>
                        {dialogs.map(dialog => (
                          <MenuItem key={dialog.id} value={dialog.id}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                              <Typography>{dialog.name}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {dialog.id}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))}
                      </ModernSelect> ) : (
                        <FormControl fullWidth>
                        <Input
                          id="file-upload"
                          type="file"
                          inputProps={{ accept: 'application/json' }}
                          onChange={handleFileUpload}
                          sx={{ display: 'none' }}
                          disabled={isProcessingFile} // Disable during processing
                        />
                        <label htmlFor="file-upload">
                          <Box
                            sx={{
                              p: 3,
                              borderRadius: '12px',
                              border: `2px dashed ${theme.palette.divider}`,
                              backgroundColor: theme.palette.background.paper,
                              cursor: isProcessingFile ? 'wait' : 'pointer',
                              transition: 'all 0.3s ease',
                              textAlign: 'center',
                              '&:hover': {
                                borderColor: isProcessingFile ? theme.palette.divider : theme.palette.primary.main,
                                backgroundColor: isProcessingFile ? theme.palette.background.paper : theme.palette.action.hover
                              },
                              ...(selectedFile && {
                                borderStyle: 'solid',
                                borderColor: theme.palette.success.main
                              })
                            }}
                          >
                            {isProcessingFile ? (
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <LinearProgress 
                                  variant="determinate" 
                                  value={processingProgress}
                                  sx={{ borderRadius: 2, height: 8 }}
                                />
                                <Typography variant="caption" color="text.secondary">
                                  Processing: {processingProgress}% completed
                                  <br />
                                  {processedData.length} valid records found
                                </Typography>
                              </Box>
                            )  : selectedFile ? (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Avatar sx={{ bgcolor: theme.palette.success.light }}>
                                  <CheckCircle sx={{ color: theme.palette.success.main }} />
                                </Avatar>
                                <Box sx={{ textAlign: 'left' }}>
                                  <Typography variant="body2" fontWeight={500}>
                                    {selectedFile.name}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    {(selectedFile.size / 1024).toFixed(2)} KB
                                  </Typography>
                                </Box>
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedFile(null);
                                    setFileContent(null);
                                  }}
                                  sx={{ ml: 'auto' }}
                                >
                                  <Close fontSize="small" />
                                </IconButton>
                              </Box>
                            ) : (
                              <>
                                <Box sx={{ mb: 1 }}>
                                  <CloudUpload
                                    sx={{
                                      fontSize: 32,
                                      color: theme.palette.text.secondary,
                                      mb: 1
                                    }}
                                  />
                                </Box>
                                <Typography variant="body2" fontWeight={500}>
                                  Drag & drop JSON file or{' '}
                                  <Box component="span" sx={{ color: theme.palette.primary.main }}>
                                    click to upload
                                  </Box>
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  Maximum file size: 5MB (JSON format only)
                                </Typography>
                              </>
                            )}
                          </Box>
                        </label>
                      </FormControl>
                      )}

                    </Box>

                    {/* <NumberSelector value={numberValue} setValue={setNumberValue} /> */}
                  </Box>
                </Box>
              </Slide>

              <Slide direction="up" in={activeStep === 2} mountOnEnter unmountOnExit>
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 2 }}>Confirm Settings</Typography>
                  <Box sx={{ p: 2, borderRadius: 2, background: theme.palette.background.default }}>
                  {[
                    { label: 'Account', value: selectedAccount?.phone_number },
                    { label: 'Source Group', value: dialogs.find(d => d.id === selectedSource)?.name },
                    { 
                      label: 'Target Option', 
                      value: targetOption === 'group' 
                        ? dialogs.find(d => d.id === selectedTarget)?.name 
                        : selectedFile?.name || 'No file selected'
                    },
                    ].map((item, i) => (
                      <Box
                        key={item.label}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          py: 1,
                          borderBottom: i < 3 ? `1px solid ${theme.palette.divider}` : 'none'
                        }}
                      >
                        <Typography variant="body2" color="text.secondary">
                          {item.label}
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {item.value || 'Not selected'}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Slide>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
              {activeStep > 0 && (
                <Button
                  startIcon={<ArrowBack />}
                  onClick={() => setActiveStep(activeStep - 1)}
                  sx={{ textTransform: 'none', borderRadius: 2 }}
                >
                  Back
                </Button>
              )}
              <Button
                variant="contained"
                onClick={activeStep === 2 ? handleCreateTask : () => setActiveStep(activeStep + 1)}
                disabled={
                  (activeStep === 0 && !selectedAccount) ||
                  (activeStep === 1 && (
                    !selectedSource || 
                    (targetOption === 'group' && !selectedTarget) ||
                    (targetOption === 'file' && !selectedFile)
                  )) ||
                  creatingTask
                }
                sx={{
                  textTransform: 'none',
                  px: 4,
                  borderRadius: 2,
                  fontWeight: 600,
                  background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`
                }}
              >
                {activeStep === 2 ? (creatingTask ? 'Starting...' : 'Launch Task') : 'Continue'}
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>








<Modal open={inviteTextModalOpen} onClose={() => setInviteTextModalOpen(false)}>
    <Fade in={inviteTextModalOpen}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 24,
        p: 3,
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
          <Typography variant="h6">Set Invite Text</Typography>
          <IconButton onClick={() => setInviteTextModalOpen(false)}>
            <Close />
          </IconButton>
        </Box>
        
        <TextField
          fullWidth
          label="Invite Text"
          value={inviteText}
          onChange={(e) => setInviteText(e.target.value)}
          multiline
          rows={4}
          sx={{ mb: 3 }}
        />
        
        <Button
          fullWidth
          variant="contained"
          onClick={handleUpdateInviteText}
          disabled={isUpdatingText || !inviteText}
        >
          {isUpdatingText ? 'Updating...' : 'Update Text'}
        </Button>
      </Box>
    </Fade>
  </Modal>

  {/* Add the Snackbar */}
  <Snackbar
    open={snackbarOpen}
    autoHideDuration={6000}
    onClose={handleCloseSnackbar}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
  >
    <Alert 
      severity={snackbarSeverity}
      sx={{ width: '100%' }}
      iconMapping={{
        success: <CheckCircleIcon fontSize="inherit" />,
        error: <ErrorIcon fontSize="inherit" />
      }}
    >
      {snackbarMessage}
    </Alert>
  </Snackbar>







      
    </Box>
  );
};

export default MembersScraper;